import api from "./index";

export async function getAppointments(params) {
  return api.get(`/appointments`, { params });
}

export async function getAppointmentsAudit(appointmentId) {
  return api.get(`/appointments/${appointmentId}/events`);
}

export async function getAppointmentById(id) {
  return api.get(`/appointments/${id}`);
}

export async function insertAppointment(body, params) {
  return api.post(`/appointments`, body, { params });
}

export async function updateAppointment(id, body) {
  return api.put(`/appointments/${id}`, body);
}

export async function cancelAppointment(id, body) {
  return api.patch(`/appointments/${id}/cancel`, body);
}

export async function startAppointment(id) {
  return api.patch(`/appointments/${id}/checkin`);
}

export async function finishAppointment(id) {
  return api.patch(`/appointments/${id}/checkout`);
}

export async function getAppointmentAvailable(params) {
  return api.get(`/appointments/available-slots`, { params });
}

export async function getAppointmentAvgTime(params) {
  return api.get(`/appointments/reports/avg-time`, { params });
}

export async function getAppointmentReportSummary(params) {
  return api.get(`/appointments/reports/summary`, { params });
}

export async function getAppointmentReportConsolidated(params) {
  return api.get(`/appointments/reports/consolidated`, { params });
}

export async function getAppointmentReportRating(params) {
  return api.get(`/appointments/reports/rating`, { params });
}

export async function getAppointmentAvailableClosest(params) {
  return api.get(`/appointments/available-slots/closest`, { params });
}

export async function getAppointmentMonthSlots(params) {
  return api.get(`/appointments/available-slots/month`, { params });
}

export async function getAppointmentsWaitingMe() {
  return api.get(`/appointments/waiting/me`);
}
